(() => {
  const config = window.euCustomsDuty;
  if (!config?.enabled) return;
  const root = window.Shopify?.routes?.root || '/';
  const dutyVariantId = Number(config.variantId);
  const dutyProductId = Number(config.productId);
  let queue = Promise.resolve();
  let pending = 0;

  const request = async (url, body) => {
    const response = await fetch(url, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(result.description || result.errors || 'Unable to update customs duty.');
    return result;
  };
  const isDuty = (item) => item.properties?._eu_customs_declaration_duty === 'true'
    || item.properties?._eu_customs_declaration_duty === true
    || (dutyProductId > 0 && Number(item.product_id) === dutyProductId)
    || (dutyVariantId > 0 && Number(item.variant_id) === dutyVariantId);
  const reconcile = async (options = {}) => {
    const cart = options.cart || await request(`${root}cart.js`);
    const goods = cart.items.filter((item) => !isDuty(item) && item.requires_shipping !== false);
    const total = goods.reduce((sum, item) => sum + item.final_line_price, 0);
    if (config.applies && (!Number.isFinite(config.threshold) || config.threshold < 0)) {
      throw new Error('The customs declaration cutoff is missing or invalid.');
    }
    const quantity = config.applies && total <= config.threshold
      ? new Set(goods.map((item) => item.product_id)).size : 0;
    if (quantity > 0 && (!dutyProductId || !dutyVariantId)) {
      throw new Error('The customs declaration service is unavailable for this market.');
    }
    const lines = cart.items.filter(isDuty);
    const current = lines.reduce((sum, item) => sum + item.quantity, 0);
    if (current === quantity && lines.length <= 1 && lines.every((item) => Number(item.variant_id) === dutyVariantId)) return cart;

    const sections = options.sections || window.mykstyleCart?.getSections?.().map((entry) => entry.id) || [];
    const rendering = sections.length ? { sections, sections_url: window.location?.pathname || root } : {};
    document.documentElement.classList.add('eu-customs-duty-syncing');
    try {
      const keeper = quantity > 0 && lines.find((item) => Number(item.variant_id) === dutyVariantId);
      let updated = cart;
      if (lines.length) {
        updated = await request(routes.cart_update_url, {
          updates: Object.fromEntries(lines.map((item) => [item.key, item === keeper ? quantity : 0])), ...rendering
        });
      }
      if (quantity > 0 && !keeper) {
        const added = await request(routes.cart_add_url, {
          items: [{ id: dutyVariantId, quantity, properties: { _eu_customs_declaration_duty: 'true' } }], ...rendering
        });
        updated = await request(`${root}cart.js`);
        updated.sections = added.sections;
      }
      if (options.refreshCartPage !== false) {
        await window.mykstyleCart?.refresh(updated.sections, updated);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updated, dutySynced: true } }));
      }
      return updated;
    } finally {
      document.documentElement.classList.remove('eu-customs-duty-syncing');
    }
  };
  config.sync = (options = {}) => {
    const input = pending ? { ...options, cart: undefined } : options;
    pending++;
    const result = queue.catch(() => {}).then(() => reconcile(input)).finally(() => { pending--; });
    queue = result;
    return result;
  };
  const schedule = (cart) => config.sync({ cart: Number.isFinite(cart?.item_count) ? cart : undefined })
    .catch((error) => console.warn('EU customs declaration duty could not be updated.', error));
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.dutySynced) return;
      return schedule(event.cartData);
    });
  }
  document.addEventListener('cart:updated', (event) => { if (!event.detail?.dutySynced) schedule(event.detail?.cart); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) schedule(); });
  document.addEventListener('DOMContentLoaded', () => {
    const cart = config.cart;
    delete config.cart;
    schedule(cart);
  }, { once: true });
})();
